import { ADS_CAMPAIGN_STATUS_ACTIVE } from "./constants";

export const campaignStatesAreMissing = (campaign) => campaign?.states == null;

export const getCampaignIDsMissingStates = ({
  items,
  campaigns = {},
} = {}) => {
  if (!Array.isArray(items) || items.length === 0) return [];

  const campaignIDs = new Set();
  items.forEach((item) => {
    const campaignID = item?.campaignID;
    if (!campaignID) return;
    if (campaignStatesAreMissing(campaigns[campaignID])) {
      campaignIDs.add(campaignID);
    }
  });

  return [...campaignIDs];
};

const getCampaignStatus = ({ campaign, statusOverrides, campaignID }) => {
  const overrideStatus = statusOverrides?.[campaignID];
  if (overrideStatus) return overrideStatus;

  return campaign?.states?.general;
};

export const shouldShowIntegrationNotFoundItem = ({
  item,
  campaigns = {},
  statusOverrides = {},
  forceShow = false,
} = {}) => {
  if (forceShow) return true;

  const campaignID = item?.campaignID;
  if (!campaignID) return false;

  const campaign = campaigns[campaignID];
  if (campaignStatesAreMissing(campaign) && !statusOverrides?.[campaignID]) {
    return false;
  }

  const status = getCampaignStatus({
    campaign,
    statusOverrides,
    campaignID,
  });

  return status === ADS_CAMPAIGN_STATUS_ACTIVE;
};

export const filterFailedIntegrationsForModal = ({
  items,
  campaigns = {},
  statusOverrides = {},
  forceShow = false,
} = {}) => {
  if (!Array.isArray(items) || items.length === 0) return [];

  return items.filter((item) =>
    shouldShowIntegrationNotFoundItem({
      item,
      campaigns,
      statusOverrides,
      forceShow,
    })
  );
};
